import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    linkTitle: PropTypes.string,
    linkUrl: PropTypes.string,
  }),
);
